// numeric-cell.directive.ts
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[numericCellNav]' })
export class NumericCellNavDirective {
  /** unique key for this column, e.g. 'pcpAAnnulusPsi' */
  @Input() colKey!: string;

  /** row index for this cell */
  @Input() rowIndex!: number;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('focus') onFocus() {
    // auto-select value
    this.el.nativeElement.select();
  }

  @HostListener('wheel', ['$event']) onWheel(e: WheelEvent) {
    // avoid accidental value changes on scroll
    (e.target as HTMLInputElement).blur();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    const key = e.key;
    const next = (r: number, c = this.colKey) =>
      document.querySelector<HTMLInputElement>(`[data-row="${r}"][data-col="${c}"]`)?.focus();

    if (key === 'Enter' || key === 'ArrowDown') {
      e.preventDefault();
      next(this.rowIndex + 1);
    } else if (key === 'ArrowUp') {
      e.preventDefault();
      next(this.rowIndex - 1);
    } else if (key === 'ArrowRight') {
      e.preventDefault();
      this.moveCol(1);
    } else if (key === 'ArrowLeft') {
      e.preventDefault();
      this.moveCol(-1);
    } else if ((key === '+' || key === '=') && !e.shiftKey) {
      // quick increment
      e.preventDefault();
      this.stepValue(1);
    } else if (key === '-') {
      e.preventDefault();
      this.stepValue(-1);
    }
  }

  private moveCol(delta: number) {
    const cols = ['pcpAAnnulusPsi','icpBAnnulusPsi','scpCAnnulusPsi','ccpDAnnulusPsi','thpPsi'];
    const idx = cols.indexOf(this.colKey);
    const nextIdx = Math.min(cols.length - 1, Math.max(0, idx + delta));
    const nextCol = cols[nextIdx];
    document.querySelector<HTMLInputElement>(`[data-row="${this.rowIndex}"][data-col="${nextCol}"]`)?.focus();
  }

  private stepValue(delta: number) {
    const input = this.el.nativeElement;
    const step = Number(input.step || 1);
    const current = Number(input.value || 0);
    const next = current + delta * step;
    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
